module.exports = __webpack_public_path__ + "img/hohlsaum_opalgruen_ral6026.feb800fb.jpg";